import { styled } from '@mui/material';

export const StyledForm = styled('form')(() => ({
  width: '100%',
  marginTop: 2,
  marginBottom: 2,
}));
